import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as API from '../../../Endpoints/endpoint';
import { useParams, useNavigate } from 'react-router-dom';
import '../../PosterData/postertable.css';
function EditPoster() {
  const { srno } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    srno: '',
    chartname: '',
    language: '',
    voice: '',
    video: '',
    summary: '',
    photopdf: ''
  });

  useEffect(() => {
    fetchPoster();
  }, []);

  const fetchPoster = async () => {
    try {
      const res = await axios.get(`${API.GET_POSTER_BY_ID}/${srno}`);
      setFormData(res.data);
    } catch (err) {
      console.error(err);
      alert('Failed to fetch poster data.');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${API.UPDATE_POSTER}/${formData.srno}`, formData);
      alert('Poster updated successfully!');
      navigate('/posterdata');
    } catch (err) {
      console.error(err);
      alert('Failed to update poster.');
    }
  };

  return (
    <div className="form-container">
      <h2>Edit Poster Data</h2>
      {Object.keys(formData).map((key) => (
        <div key={key} className="form-group">
          <label>{key.toUpperCase()}</label>
          <input
            type="text"
            name={key}
            value={formData[key]}
            onChange={handleChange}
          />
        </div>
      ))}

      <div className="form-buttons">
        <button className="btn-submit" onClick={handleUpdate}>
          Update
        </button>
        <button className="btn-cancel" onClick={() => navigate('/posterdata')}>
          Go Back
        </button>
      </div>
    </div>
  );
}

export default EditPoster;
